import React from "react"
import PropTypes from "prop-types"

// Utils
import { camelToTitleCase } from "../utils"

const HeaderRow = props => {
  const { rowSpacing, keys } = props

  return (
    <div className="scores-hr d-flex">
      {keys.map(key => (
        <div
          key={`th-${key}`}
          style={rowSpacing}
          className="scores-th d-flex justify-content-center font-weight-bold text-truncate"
        >
          <p className="text-truncate">{camelToTitleCase(key)}</p>
        </div>
      ))}
    </div>
  )
}

export default HeaderRow

HeaderRow.propTypes = {
  rowSpacing: PropTypes.shape({
    flex: PropTypes.string,
    minWidth: PropTypes.string
  }).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired
}
